/**
  メイントップページ
*/
<template>
  <v-ons-page>
    <ms-toolbar  :mode="propData.page_type=='9'?'normal':'back'" title="Home"></ms-toolbar>
    <div class="content">
      
      <div class="page_container" v-if="refresh">
        <div class="link_block" :key="page_no" v-for="(item, page_no) in propData.items"
          @click="handleClickLink(item)"
          :style="{top: item.top, left: item.left, width: item.width, height: item.height}"
          :class="checkLinkStatus(item)" :data-status="item.goods_status" :data-status2="item.goods_status2" :lock-time="item.lock_time"
          >
          <div class=notice_block>
            <img src="../assets/img/notice.svg" class="ico_notice" alt="">
            <p class="txt_notice" v-html="getStatusText(item)"></p>
          </div>
          <ons-ripple class="ripple"></ons-ripple>
        </div>
        <img class="bg_img" v-on:load="completeBgImg" :src="propData.page_img" alt="">
      </div>
    </div>
    <!--カートボタン-->
   <v-ons-fab position="bottom right" :visible="CartVisible" class="cart_fab" style="" @click="showCartPage">
      <span class="notification">{{CartItemCount}}</span>
      <v-ons-icon icon="fa-shopping-cart"></v-ons-icon>
   </v-ons-fab>
   
   <!--
   <v-ons-action-sheet
      :visible.sync="SubmenuActionVisible"
      cancelable
      title="メニューを選んでください"
      style="bottom:60px"
    >
    <v-ons-action-sheet-button icon="md-square-o" @click="moveExMenu(item)" :class="{active: $store.getters.currentMenu=='menu'}"
      v-for="(item, index) in SubMenuList" :key="index">
      <div v-if="currentLangCode=='ja'">{{item.GoodsName}}</div>
      <div v-if="currentLangCode=='en'">{{item.GoodsNamee}}</div>
      <div v-if="currentLangCode=='ch'">{{item.GoodsNamec}}</div>
    </v-ons-action-sheet-button>
      <v-ons-action-sheet-button icon="md-square-o" @click="SetSubmenuActionVisible(false)">{{ $store.getters.localizeLabel("Common", "close")}}</v-ons-action-sheet-button>
    </v-ons-action-sheet>
    -->
    <ms-tabbar ></ms-tabbar>
  </v-ons-page>
</template>

<script>
import Tabbar from "../components/msTabbar";
import Toolbar from "../components/msToolbar";
import CartPage from "./CartPage";
//import WaitingIcon from "../components/WaitingIcon";
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
//import "moment/locale/ja";


export default {
  name: "home",
  props:{
    propData: { type: Object, default: null }
  },
  data() {
    return {
      //propData:null,
      refresh: true,
      actionSheetVisible: false,
      timer:null,
    };
  },
  created: function() {
    const self=this
    //this.getGoodsStatus(this.$attrs.propData)
    //this.propData=this.$attrs.propData
    this.setLoadingScreenVisibility(true)
    console.log(this.propData)
    
  },
  updated:function(){
    //カートの件数が20件に達した場合はアラートを出して確認ページへ遷移
    if(this.CartItemCount>=20){
      this.showErrorMessage('カートの件数が多くなりましたので、いったんオーダーを送信してください。')
      this.showCartPage()
    }
  },
  computed: {
    ...mapGetters([
      //'WPPage',
      'HistoryPageVisible',
      'CartVisible',
      'CartPageVisible',
      'CartItemCount',
      'CartItems',
      'GoodsStatus',
      'checkLinkStatus',
      'getStatusText',
      'SubMenuList',
      'SubmenuActionVisible',
      'currentLangCode',
      ]),
  },
  methods: {
    ...mapActions([
      "navigateWPPage",
      'navigateLink',
      'SetCurrentSubmenu',
      'SetSubmenuActionVisible',
      "navigateOrderPage",
      'SetCartPageVisible',
      'GetGoodsStatus',
      'GetWPPage',
      'setLoadingScreenVisibility',
     ]),
    completeBgImg(){
      this.setLoadingScreenVisibility(false)
      this.getGoodsStatus(this.propData)
    },
    handleClickLink(item){
      if(item.type=="outpage-link"){
         window.open(item.code, '_blank')
      }else{
        clearTimeout(this.timer)
        this.navigateLink({item:item})
      }
      
    },
    moveExMenu(submenu){
      this.navigateWPPage(submenu.Goods)
      .then(()=>{
        this.SetCurrentSubmenu(submenu)
        this.actionSheetVisible=false
      })
      .catch(error=>{

      })
      
    },
    showCartPage(){
      //欠品情報を再取得
      var param=[]
      this.CartItems.forEach(item=>{
        if(item.code!='')
         param.push({ code:item.code})
      })
      this.setLoadingScreenVisibility(true)
      this.GetGoodsStatus(param)
      .then(()=>{
        //取得したステータスをページ設定アイテムに詰める
        //this.showLogMessage('欠品照会API取得')
        this.CartItems.forEach(item=>{
            var check=false
            this.GoodsStatus.forEach(goods=>{
              //欠品
              if(Number(item.code)==Number(goods.Goods) ){
                if(goods.GoodsStatus=='2'){
                  check=true
                }
              }
            })
            item['disabled']=check
        })
        this.SetCartPageVisible(true) 
        this.CartItems[0].count++
        this.CartItems[0].count--
        this.setLoadingScreenVisibility(false)
      })
      .catch(()=>{
        this.setLoadingScreenVisibility(false)
      })
    },
    getGoodsStatus(page){
      var param=[]
      page.items.forEach(item=>{
        //item['goods_status']='1'
        //item['goods_status2']='0'
        if(item.code!='' && item.type=='item-link')
        //複数商品の場合、欠品情報を取得しない
          if(item.code.indexOf(',')<0){
            param.push({ code:item.code, no:item.no})
          }else{
            item['goods_status']='1'
            item['goods_status2']='0'
          }
      })
      
      //this.setLoadingScreenVisibility(true)
      if(param.length>0){
        this.GetGoodsStatus(param)
        .then(goods_status=>{
          //goods_statusは存在しない商品コードでリクエストした場合、その商品のレスポンスは抜けた状態で帰ってくる
          //したがって、paramsの中身とgoods_statusの中身をチェックして、goods_statusに存在しないものはparamsから削除する
          var params=[]
          param.forEach(para=>{
            var check=false
            goods_status.forEach(goods=>{
              if(Number(para.code)==Number(goods.Goods)){
                check=true
              }
            })
            if(check==true){
              //goods_statusに存在する商品だけ詰め直す
              params.push(para)
            }  
          })
          
          //取得したステータスをページ設定アイテムに詰める
          //this.showLogMessage('欠品照会API取得')
          //同じ商品コードのリンク要素が複数あるので、LinkのNoとつきあわせる
          var param_idx=0
          goods_status.forEach(goods=>{
            page.items.forEach(item=>{
              
              if(Number(item.code)==Number(goods.Goods) && param[param_idx].no==item.no){
                item['goods_status']=goods.GoodsStatus
                item['goods_status2']=goods.GoodsStatus2
                item['lock_time']=goods.LockTime
              }
            })
            param_idx++
          })
          this.refresh = false;
          this.refresh = true; //強制的にカルーセルを再描画
          //this.setLoadingScreenVisibility(false)
        })
        .catch(()=>{
          //this.setLoadingScreenVisibility(false)
        })
      }
      
    }
  },
  
  components: {
    "ms-tabbar": Tabbar,
    "ms-toolbar": Toolbar,
    "ms-cartPage": CartPage,
    //"mc-waiting-icon": WaitingIcon
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
.content{
  background-color: #111!important;
  color: $base-font-color;
}

#link1{
  top: 0;
  width: 100vw;
  height: calc(100vw*190/750*2);
}
#link2{
  top: calc(100vw*190/750*2);
  width: 100vh;
  height: calc(100vw*170/750*2);
}
#link3{
  top: calc(100vw*360/750*2);
  width: 100vh;
  height: calc(100vw*190/750*2);
}
#link4{
  top: calc(100vw*550/750*2);
  width: 100vh;
  height: calc(100vw*200/750*2);
}

</style>



// WEBPACK FOOTER //
// src/pages/SinglePage.vue